import { useState , useEffect , useRef } from "react";
import { IoIosMenu } from "react-icons/io";
import Logo from "../assets/images/logo.webp";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";
import VipTour from "./VipTour";

const Header = () => {
  const [openedMenu, setOpenedMenu] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showVipTour, setShowVipTour] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const dropdownRef = useRef(null);
  

   useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY >= 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  return (
    <>
      <header
          className={`relative z-999 transition-all duration-300 ${
            isScrolled ? "scrolled" : ""
          }`}
        >
        <div class="container mx-auto 2xl:px-0 lg:px-[25px] px-[15px] relative">
          <nav class="w-full py-[10px] transition duration-300 ease relative top-0 start-0 w-full newClass z-[99] top-0">
            <div class="flex flex-wrap items-center justify-between w-full px-4 text-lg text-gray-700 bg_white">
              <div>
                <Link to="/">
                  <img
                    src={Logo}
                    alt="logo"
                    class="2xl:w-[160px] xl:w-[140px] w-[120px]"
                  />
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <span
                  onClick={() => setShowVipTour(true)}
                  class="lg:hidden inline-block text-[#442202] bg-[#FBBA00] lg:py-2 py-1.5 lg:px-5 px-3 lg:rounded-[8px] rounded-[6px] text-[12px] text-nowrap no-underline xl:text-[16px] lg:text-[14px] text-[12px] font-semibold cursor-pointer"
                >
                  VIP tour
                </span>
                <div
                  class="lg:hidden flex items-center border border-white bg-[#FFFFFF66] text-[#442202] h-[30px] w-[30px]  p-[5px]   leading-[1] rounded-[4px]"
                  onClick={() => setOpenedMenu(!openedMenu)}
                >
                  <svg
                    class="w-[20px] cursor-pointer"
                    fill="#000000"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="20px"
                    height="20px"
                    viewBox="0 0 0.5 0.5"
                    enable-background="new 0 0 20 20"
                    xmlSpace="preserve"
                  >
                    <path d="M0.475 0.125H0.025c-0.015 0 -0.025 -0.01 -0.025 -0.025s0.01 -0.025 0.025 -0.025h0.45c0.015 0 0.025 0.01 0.025 0.025s-0.01 0.025 -0.025 0.025z"></path>
                    <path d="M0.25 0.275H0.025c-0.015 0 -0.025 -0.01 -0.025 -0.025s0.01 -0.025 0.025 -0.025h0.225c0.015 0 0.025 0.01 0.025 0.025s-0.01 0.025 -0.025 0.025z"></path>
                    <path d="M0.475 0.425H0.025c-0.015 0 -0.025 -0.01 -0.025 -0.025s0.01 -0.025 0.025 -0.025h0.45c0.015 0 0.025 0.01 0.025 0.025s-0.01 0.025 -0.025 0.025z"></path>
                  </svg>
                </div>
              </div>
              <div
                class={`w-full lg:flex lg:items-center lg:w-auto lg:grow lg:p-0 p-5 lg:pt-[0] pt-[20px] ${
                  openedMenu
                    ? "block bg-white text-[#442202] mobile-menu"
                    : "hidden text-[#442202]"
                }`}
              >
                <ul class="lg:flex block ml-auto items-center gap-6">
                  <li class="relative nav-li active">
                    <Link
                      to={"/"}
                      class="relative lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      Home
                    </Link>
                  </li>
                  <li class="relative nav-li ">
                    <Link
                      to={"/about"}
                      class="relative lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      About
                    </Link>
                  </li>
                  <li ref={dropdownRef} class="group relative nav-item nav-li">
                    <a
                      onClick={() => setShowDropdown(!showDropdown)}
                      class="relative cursor-pointer text-[#442202]  lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      Book <FaAngleDown className="inline-block ml-1" />
                    </a>
                    {showDropdown && (
                      <ul class="absolute left-0 top-full pl-4  min-w-[10rem] py-2 m-0 text-base text-[#212529] text-left list-none bg-white bg-clip-padding rounded submenus  transition-all duration-300 ease-in-out z-[9999]">
                        <li>
                          <Link
                            to="/asakusa-gokart-route"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Asakusa
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/shibuya-gokart-route"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Shibuya
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/shinagawa-gokart-route"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Tokyo Tower
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/shinjuku-gokart-route"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Shinjuku
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/rainbow-bridge-gokart-route"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Rainbow Bridge
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/osaka-gokart-route"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Osaka
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/jdm-tour-tokyo"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            JDM Tour
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/mt-fuji-tour"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Mt. Fuji Tour
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/helicopter-ride"
                            class="block text-black block py-[5px] no-underline transition"
                          >
                            Helicopter Ride
                          </Link>
                        </li>
                        
                      </ul>
                    )}
                  </li>
                  <li class="relative nav-li">
                    <Link
                      to={"/driver-license"}
                      class="relative lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      License
                    </Link>
                  </li>
                      <li class="relative nav-li">
                    <Link
                      to={"/faq"}
                      class="relative lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      FAQ
                    </Link>
                  </li>
                  <li class="relative nav-li">
                    <Link
                      to={"/blogs"}
                      class="relative lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      Blogs
                    </Link>
                  </li>
                  <li class="relative nav-li">
                    <Link
                      to={"/contact"}
                      class="relative lg:px-[7px]   lg:py-[10px] py-[8px] block  text-[16px] ease-in duration-300 transition"
                    >
                      Contact
                    </Link>
                  </li>
                  <li class="flex overflow-hidden lg:block hidden">
                    <span
                      onClick={() => setShowVipTour(true)}
                      class="inline-block text-[#442202] bg-[#FBBA00] py-2 px-5 lg:rounded-[8px] rounded-[6px] text-[12px] no-underline xl:text-[16px] lg:text-[14px] text-[12px] font-semibold cursor-pointer"
                    >
                      VIP tour
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>
      <VipTour isOpen={showVipTour} onClose={() => setShowVipTour(false)} />
    </>
  );
};

export default Header;
